import { cn } from "../../utils/cn";
import { formatINR, formatINRNumber } from "../../utils/format";

interface CurrencyDisplayProps {
  amount: number;
  /** Right-align by default — required for financial columns. */
  align?: "right" | "left";
  hideSymbol?: boolean;
  className?: string;
  tone?: "default" | "danger" | "success";
}

const TONES = {
  default: "text-foreground-950",
  danger: "text-danger-600",
  success: "text-success-600",
};

/**
 * The single money display in the app. Always uses Indian lakh/crore grouping,
 * the rupee symbol, two decimals and tabular figures.
 */
export function CurrencyDisplay({
  amount,
  align = "right",
  hideSymbol = false,
  className,
  tone = "default",
}: CurrencyDisplayProps) {
  return (
    <span className={cn("tnum inline-block", align === "right" ? "text-right" : "text-left", TONES[tone], className)}>
      {hideSymbol ? formatINRNumber(amount) : formatINR(amount)}
    </span>
  );
}